/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * API Reference
 * OpenAPI spec version: 1.0
 */

export type GetPayoutQuoteBodyMethod = typeof GetPayoutQuoteBodyMethod[keyof typeof GetPayoutQuoteBodyMethod];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetPayoutQuoteBodyMethod = {
  UNIONPAY: 'UNIONPAY',
  ALIPAY: 'ALIPAY',
} as const;
